import Accordion from './src/components/Accordion/index';
import AlertBar from './node_modules/tbk-components/src/components/AlertBar/index.js';
import AlternatingTextAndImages from './src/components/AlternatingTextAndImages/index';
import BlogRollPagination from './node_modules/tbk-components/src/components/BlogRoll/BlogRollPagination.js';
import BlogRollPostItem from './src/components/BlogRoll/BlogRollPostItem';
import BlogRollPosts from './src/components/BlogRoll/BlogRollPosts';
import BlogRollTile from './node_modules/tbk-components/src/components/BlogRoll/BlogRollTile.js';
import BlogRoll from './node_modules/tbk-components/src/components/BlogRoll/index.js';
import BlogRollWithFeaturedPost from './src/components/BlogRollWithFeaturedPost/index';
import CompanyStats from './src/components/CompanyStats/index';
import CTABar from './src/components/CTABar/index';
import DonationCallouts from './src/components/DonationCallouts/index';
import DonationForm from './src/components/DonorTool/DonorToolComponents/DonationForm';
import DonationFormButtons from './src/components/DonorTool/DonorToolComponents/DonationFormButtons';
import DonorToolCart from './src/components/DonorTool/DonorToolComponents/DonorToolCart';
import DonorToolGravityFormContainer from './src/components/DonorTool/DonorToolComponents/DonorToolGravityFormContainer';
import DonorToolHeader from './src/components/DonorTool/DonorToolComponents/DonorToolHeader';
import DonorToolPaymentTypeInfo from './src/components/DonorTool/DonorToolComponents/DonorToolPaymentTypeInfo';
import DonorTool from './src/components/DonorTool/index';
import Footer from './src/components/Footer/index';
import Form from './src/components/Form/index';
import GeneralStylesheetContainer from './src/components/GeneralStylesheetContainer/index';
import GTMHandler from './src/components/GTMHandler/index';
import Header from './src/components/Header/index';
import ImageBar from './src/components/ImageBar/index';
import LargeGallery from './src/components/LargeGallery/index';
import LocationList from './src/components/LocationList/index';
import LocationListFilter from './src/components/LocationList/LocationListFilter';
import LocationListPagination from './src/components/LocationList/LocationListPagination';
import LocationListRecords from './src/components/LocationList/LocationListRecords';
import LocationListResults from './src/components/LocationList/LocationListResults';
import LocationMap from './src/components/LocationMap/index';
import NewsletterSignup from './src/components/NewsletterSignup/index';
import PrettyPDF from './src/components/PrettyPDF/index';
import RegionAccordion from './src/components/RegionAccordion/index';
import RegionHeroBanner from './src/components/RegionHeroBanner/index';
import ResponsiveSpacer from './src/components/ResponsiveSpacer/index';
import RotatingHeroBanner from './src/components/RotatingHeroBanner/index';
import SocialMediaBar from './src/components/SocialMediaBar/index';
import Stat from './src/components/Stat/index';
import Tags from './src/components/Tags/index';
import TeamModule from './src/components/TeamModule/index';
import TestimonialsCarousel from './src/components/TestimonialsCarousel/index';
import ThemeHeroBanner from './src/components/ThemeHeroBanner/index';
import TypographySamples from './src/components/TypographySamples/index';
import Blockquote from './node_modules/tbk-components/src/components/Blockquote/index.js';
import BlogRollFilterBar from './node_modules/tbk-components/src/components/BlogRoll/BlogRollFilterBar.js';
import BlogRollHero from './node_modules/tbk-components/src/components/BlogRoll/BlogRollHero.js';
import BlogRollPage from './node_modules/tbk-components/src/components/BlogRoll/BlogRollPage.js';
import BlogRollSingle from './node_modules/tbk-components/src/components/BlogRoll/BlogRollSingle.js';
import Container from './node_modules/tbk-components/src/components/Container/index.js';
import LogoBar from './node_modules/tbk-components/src/components/LogoBar/index.js';
import RawHTML from './node_modules/tbk-components/src/components/RawHTML/index.js';
import Tab from './node_modules/tbk-components/src/components/Tab/index.js';
import Tabs from './node_modules/tbk-components/src/components/Tabs/index.js';

const components = {
	Accordion,
	AlertBar,
	AlternatingTextAndImages,
	BlogRollPagination,
	BlogRollPostItem,
	BlogRollPosts,
	BlogRollTile,
	BlogRoll,
	BlogRollWithFeaturedPost,
	CompanyStats,
	CTABar,
	DonationCallouts,
	DonationForm,
	DonationFormButtons,
	DonorToolCart,
	DonorToolGravityFormContainer,
	DonorToolHeader,
	DonorToolPaymentTypeInfo,
	DonorTool,
	Footer,
	Form,
	GeneralStylesheetContainer,
	GTMHandler,
	Header,
	ImageBar,
	LargeGallery,
	LocationList,
	LocationListFilter,
	LocationListPagination,
	LocationListRecords,
	LocationListResults,
	LocationMap,
	NewsletterSignup,
	PrettyPDF,
	RegionAccordion,
	RegionHeroBanner,
	ResponsiveSpacer,
	RotatingHeroBanner,
	SocialMediaBar,
	Stat,
	Tags,
	TeamModule,
	TestimonialsCarousel,
	ThemeHeroBanner,
	TypographySamples,
	Blockquote,
	BlogRollFilterBar,
	BlogRollHero,
	BlogRollPage,
	BlogRollSingle,
	Container,
	LogoBar,
	RawHTML,
	Tab,
	Tabs
};

export default components;
